import { ApiService } from 'services';

const URL_SUBSCRIPTIONS = '/subscriptions';

async function getSubscriptions(tokenId) {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_SUBSCRIPTIONS}/tokens/${tokenId}/me`,
  });
}

async function getSubscriptionOrders({ subscriptionId, tokenId, ...request }) {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_SUBSCRIPTIONS}/${subscriptionId}/tokens/${tokenId}/investor-orders/me`,
    queryParams: request,
  });
}

async function getSubscriptionOrder({ subscriptionId, tokenId, orderId }) {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_SUBSCRIPTIONS}/${subscriptionId}/tokens/${tokenId}/investor-orders/${orderId}`,
  });
}

async function postSubscriptionOrdersAction({ subscriptionId, tokenId, orderId, action }) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `${URL_SUBSCRIPTIONS}/${subscriptionId}/tokens/${tokenId}/investor-orders/${orderId}/${action}/me`,
  });
}

export default {
  getSubscriptionOrder,
  getSubscriptionOrders,
  getSubscriptions,
  postSubscriptionOrdersAction,
};
